import React, { useState, useEffect } from "react";

const FoodExpense = ({ 
 value,
  t, 
  isAllowanceOutSTaxFree, 
  register, 
  setValue,
}) => {
  const [selectedFoodExpense, setSelectedFoodExpense] = useState(0);
  const [breakfast, setBreakfast] = useState(60);
  const [lunchOrDinner, setLunchOrDinner] = useState(105);
  const [lunchAndDinner, setLunchAndDinner] = useState(210);
  const [bratFastLunchDinner, setBratFastLunchDinner] = useState(270);

  const foodExpenseOptions = [
    { label: t("No food expense"), value: 0 },
    { label: t("Breakfast"), value: breakfast },
    { label: t("Lunch or Dinner"), value: lunchOrDinner },
    { label: t("Lunch and Dinner"), value: lunchAndDinner },
    { label: t("Breakfast, Lunch and Dinner"), value: bratFastLunchDinner },
  ];
   useEffect(() => {
      const numericValue = parseInt(value) || 0;
      setSelectedFoodExpense(numericValue);
      setValue("foodAllowance", numericValue);
      setValue("dailyFoodRate", numericValue);
  }, [value, setValue]);

  function handleFoodExpenseChange(event) {
    const newValue = parseInt(event.target.value);
    setSelectedFoodExpense(newValue);
    setValue("foodAllowance", newValue);
    setValue("dailyFoodRate", newValue);
  }

  return (
    <>
      {isAllowanceOutSTaxFree ? (
        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="foodExpense" className="text-muted small">
            {t("Food Expense")}
          </label>
          <select
            className="form-control shadow-sm rounded"
            id="foodExpense"
            value={selectedFoodExpense}
            onChange={handleFoodExpenseChange}
          >
            {foodExpenseOptions.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label} {option.value > 0 ? ` (${option.value} SEK)` : ''}
              </option>
            ))}
          </select>

          <input
            type="hidden"
            {...register("foodAllowance")}
          />
          <input
            type="hidden"
            {...register("dailyFoodRate")}
          />
        </div>
      ) : null}
    </>
  );
};

export default FoodExpense;